// extracted by mini-css-extract-plugin
export default {"smart-matching-loading-state":"style_smart-matching-loading-state__yBfb9","smartMatchingLoadingState":"style_smart-matching-loading-state__yBfb9"};